var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 200C155.04 200 200 154.96 200 100C200 44.96 154.96 0 100 0C44.96 0 0 45.04 0 100C0 155.04 45.04 200 100 200Z",
    fill: "url(#paint0_linear_10551_25522)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.96 121.6L157.28 105.28C158.8 104.4 159.68 102.8 159.68 101.04V68.3999C159.68 66.6399 158.72 65.0399 157.28 64.1599L128.96 47.8399C127.44 46.9599 125.6 46.9599 124.08 47.8399L95.76 64.1599C94.24 65.0399 93.36 66.6399 93.36 68.3999V126.8L73.52 138.24L53.68 126.8V103.92L73.52 92.4799L86.64 99.9999V84.6399L76 78.4799C75.28 78.0799 74.4 77.8399 73.6 77.8399C72.72 77.8399 71.92 78.0799 71.2 78.4799L42.88 94.7999C41.36 95.6799 40.48 97.2799 40.48 99.0399V131.68C40.48 133.44 41.44 135.04 42.88 135.92L71.2 152.24C72.72 153.12 74.56 153.12 76.08 152.24L104.4 135.92C105.92 135.04 106.8 133.44 106.8 131.68V73.2799L107.12 73.0399L126.64 61.7599L146.48 73.1999V96.0799L126.64 107.52L113.6 99.9999V115.36L124.24 121.52C125.76 122.4 127.6 122.4 129.12 121.52L128.96 121.6Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10551_25522",
    x1: -36.5787,
    y1: 16.2409,
    x2: 169.661,
    y2: 142.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A229C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B3FE4"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.feda083b1a21ab9cf95e2ce7032e1ecd.svg";
export { ForwardRef as ReactComponent };